export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./banners.vue?vue&type=template&id=e779ee0e"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/banners.vue?vue&type=template&id=e779ee0e
// module id = 2X4a
// module chunks = 0